/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_Mock_Rule3_CondInputs */

const tr_landing_pricerules_mock_rule3_cond = /** @type {(inputs: Landing_Pricerules_Mock_Rule3_CondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD veya EUR %2 artarsa`)
};

const en_landing_pricerules_mock_rule3_cond = /** @type {(inputs: Landing_Pricerules_Mock_Rule3_CondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD or EUR rises 2%`)
};

const de_landing_pricerules_mock_rule3_cond = /** @type {(inputs: Landing_Pricerules_Mock_Rule3_CondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD oder EUR steigt um 2%`)
};

const ru_landing_pricerules_mock_rule3_cond = /** @type {(inputs: Landing_Pricerules_Mock_Rule3_CondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD или EUR растет на 2%`)
};

/**
* | output |
* | --- |
* | "USD or EUR rises 2%" |
*
* @param {Landing_Pricerules_Mock_Rule3_CondInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_mock_rule3_cond = /** @type {((inputs?: Landing_Pricerules_Mock_Rule3_CondInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_Mock_Rule3_CondInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_mock_rule3_cond(inputs)
	if (locale === "de") return de_landing_pricerules_mock_rule3_cond(inputs)
	if (locale === "ru") return ru_landing_pricerules_mock_rule3_cond(inputs)
	return tr_landing_pricerules_mock_rule3_cond(inputs)
});